import React from 'react';
import { Table } from 'react-bootstrap';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select from '../components/forms/Select';
import { getLocalizedName } from '../localization/LocalizedString';

class InstallationServiceSubcontractor extends React.Component {
  render() {
    const {
      translate,
      currentLanguage,
      importedSubcontractors,
      selectedSubcontractor,
      onChangeHandler,
      isEditState,
      session: { isAdmin = false },
    } = this.props;

    const localizedName = getLocalizedName(selectedSubcontractor, currentLanguage);

    return (
      <div>
        <Table className="table-width" bordered>
          <thead className="table-head">
            <tr>
              <th>{translate('service_installation.subcontractor_title')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <h3 className="table-body-text-padding">
                  {translate('service_installation.select_subcontractor')}
                </h3>
                <div className="row">
                  <div className="col-sm-6 col-md-offset-3">
                    <Select
                      disabled={!isAdmin && isEditState}
                      value={selectedSubcontractor != null
                        ? selectedSubcontractor.companyBusinessId
                        : ''}
                      name="subcontractorSelect"
                      placeholder={translate('service_installation.select_subcontractor')}
                      required
                      onChange={onChangeHandler}
                      data={importedSubcontractors.map((subcontractor) => ({
                        value: subcontractor.companyBusinessId,
                        text: `${subcontractor.companyBusinessId}, ${getLocalizedName(subcontractor, currentLanguage)}`,
                      }))} />
                    <div className="container">
                      <div className="row">
                        <p className="col-sm-1"><b>{translate('service_installation.code')}</b></p>
                        <p className="col-sm">
                          {selectedSubcontractor != null
                            ? selectedSubcontractor.companyBusinessId
                            : '-'}
                        </p>
                      </div>
                      <div className="row">
                        <p className="col-sm-1"><b>{translate('service_installation.name')}</b></p>
                        <p className="col-sm">
                          {localizedName != null
                            ? localizedName
                            : '-'}
                        </p>
                      </div>
                      <div className="row">
                        <p className="col-sm-1"><b>{translate('service_installation.phone')}</b></p>
                        <p className="col-sm">
                          {selectedSubcontractor != null
                            ? selectedSubcontractor.phone
                            : '-'}
                        </p>
                      </div>
                      <div className="row">
                        <p className="col-sm-1"><b>{translate('service_installation.email')}</b></p>
                        <p className="col-sm">
                          {selectedSubcontractor != null
                            ? selectedSubcontractor.email
                            : '-'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);
  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceSubcontractor);
